// import React, { useState, useEffect } from 'react';
// // ✅ Import useSearchParams
// import { useSearchParams } from 'react-router-dom';
// import '../Styles/Sidebar.css';
// import sidebarimg1 from '../images/sidebarimg1.jpg';
// import sidebarimg2 from '../images/sidebarimg2.jpg';
// import sidebarimg3 from '../images/sidebarimg3.jpg';
// import sidebarimg4 from '../images/sidebarimg4.jpg';
// import HairCare from './HairCare';
// import HairMakeOver from './HairMakeOver';
// import FacialsSection from './FacialsSection';
// import SkinGroomingSection from './SkinGroomingSection';






// const Sidebar = () => {

  
//     const services = [
//       { name: 'Hair Care', icon: sidebarimg1 },
//       { name: 'Hair Makeover', icon: sidebarimg2 },
//       { name: 'Facials', icon: sidebarimg3 },
//       { name: 'Grooming', icon: sidebarimg4 },
//     ];

//   //selected service component here by link=/service/service=service-name logic here
//   const [searchParams] = useSearchParams();
//   const selectedService = searchParams.get('service');

//   const renderServiceComponent = () => {
//     switch (selectedService) {
//       case 'Hair Care':
//         return <HairCare />;
//       case 'Hair Makeover':
//         return <HairMakeOver />;
//       case 'Facials':
//         return <FacialsSection />;
//       case 'Grooming':
//         return <SkinGroomingSection />;
//       default:
//         return <HairCare />; // default component
//     }
//   };

//   return (
//     <div className="services-container">

//       <div className="sidebar">
//         {services.map((service) => (
//           <div>
//               <img src={service.icon}  className="service-icon" />
//             <p className="service-label">{service.name}</p>
//           </div>
//         ))}
//       </div>

//       <div className="services-content">
//         <div className="service-details">
//             {/* // selected service component here by link=/service/servic=service-name */}
//             <HairCare />
//             <HairMakeOver />
//             <FacialsSection />
//             <SkinGroomingSection />
//           </div>
      
//       </div>
//     </div>
//   );
// };

// export default Sidebar;

import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import '../Styles/Sidebar.css';
import sidebarimg1 from '../images/sidebarimg1.jpg';
import sidebarimg2 from '../images/sidebarimg2.jpg';
import sidebarimg3 from '../images/sidebarimg3.jpg';
import sidebarimg4 from '../images/sidebarimg4.jpg';
import HairCare from './HairCare';
import HairMakeOver from './HairMakeOver';
import FacialsSection from './FacialsSection';
import SkinGroomingSection from './SkinGroomingSection';

// ✅ NEW: A custom hook to detect if the screen is mobile-sized.
const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
};


// Helper maps and functions remain the same...
const serviceUrlMap = {
  'hair-care': 'Hair Care',
  'hair-makeover': 'Hair Makeover',
  'facials': 'Facials',
  'grooming': 'Grooming',
};

const nameToSlug = (name) => {
  return name.toLowerCase().replace(' ', '-');
};

const Sidebar = () => {
  const { serviceParam } = useParams();
  const [selectedService, setSelectedService] = useState('Hair Care');
  
  // ✅ Use the custom hook to get the mobile status.
  const isMobile = useIsMobile();

  // This effect for setting the selected service remains the same.
  useEffect(() => {
    // Default to the first service if no parameter is in the URL on page load.
    const defaultSlug = nameToSlug(services[0].name);
    const slug = serviceParam ? serviceParam.split('=')[1] : defaultSlug;
    
    const serviceName = serviceUrlMap[slug];
    if (serviceName) {
      setSelectedService(serviceName);
    }
  }, [serviceParam]);

  // ✅ NEW: This effect handles scrolling on mobile view.
  useEffect(() => {
    // Only run this logic on mobile devices.
    if (isMobile && serviceParam) {
      const slug = serviceParam.split('=')[1];
      
      // Use a small timeout to ensure the element is rendered before we scroll.
      setTimeout(() => {
        const element = document.getElementById(slug);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, [serviceParam, isMobile]); // Rerun when the service or view mode changes.

  const services = [
    { name: 'Hair Care', icon: sidebarimg1 },
    { name: 'Hair Makeover', icon: sidebarimg2 },
    { name: 'Facials', icon: sidebarimg3 },
    { name: 'Grooming', icon: sidebarimg4 },
  ];
  
  const serviceComponentMap = {
    'Hair Care': <HairCare />,
    'Hair Makeover': <HairMakeOver />,
    'Facials': <FacialsSection />,
    'Grooming': <SkinGroomingSection />,
  };

  return (
    <div className="services-container">
      <div className="sidebar">
        {services.map((service) => (
          <Link 
            key={service.name} 
            to={`/Service/service=${nameToSlug(service.name)}`}
            style={{ textDecoration: 'none' }}
          >
            <div
              className={`sidebar-item ${selectedService === service.name ? 'selected' : ''}`}
            >
              <img src={service.icon} alt={`${service.name} icon`} className="service-icon" />
              <p className="service-label">{service.name}</p>
            </div>
          </Link>
        ))}
      </div>

      <div className="services-content">
        {/* ✅ MODIFIED: Use conditional rendering based on screen size. */}
        {isMobile ? (
          // --- MOBILE VIEW ---
          // Render all components, each with a unique ID for scrolling.
          <>
            <div id="hair-care"><HairCare /></div>
            <div id="hair-makeover"><HairMakeOver /></div>
            <div id="facials"><FacialsSection /></div>
            <div id="grooming"><SkinGroomingSection /></div>
          </>
        ) : (
          // --- DESKTOP VIEW ---
          // Render only the selected component.
          <div className="service-details">
            {serviceComponentMap[selectedService]}
          </div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;